<template>

    <div class="form-group personalized-game-editor-list">
        <label>{{ element.display_name }} ({{ t.__('lista') }}{{ labelExtraText }})</label>
        <div class="hint-text" v-if="hint !== ''" v-html="hint"></div>
        <table v-if="element.elements.length > 0">
            <draggable tag="tbody" :list="element.elements" v-bind="elementsDragOptions" @change="handleInput">
                <tr v-for="(childElement, index) in element.elements" :key="childElement.name">
                    <td class="counter">
                        <div class="d-flex align-items-center">
                            <div class="list-element-handler"></div> {{ (index + 1) }}.
                        </div>
                    </td>
                    <td class="element">
                        <personalized-game-editor-element v-model="element.elements[index]" @input="handleInput" :location="elementLocation" :hide-label="true"></personalized-game-editor-element>
                    </td>
                    <td class="remove-element">
                        <i class="fa fa-trash" @click="removeElement(index)"></i>
                    </td>
                </tr>
            </draggable>
        </table>

        <div v-if="element.max_length === 0 || element.elements.length < element.max_length">
            <b-button size="sm" variant="primary" class="add-element" @click="addElement">{{ t.__('Dodaj element') }}</b-button>
        </div>
        <div class="d-block invalid-feedback" v-if="error">{{ error }}</div>
    </div>

</template>

<script>

import mime from 'mime';
import draggable from 'vuedraggable'

export default {

    name: 'PersonalizedGameEditorEditorList',

    components: {
        draggable
    },

    props: {
        value: Object,
        location: String
    },

    data() {
        return {
            eventHub: window.eventHub,
            element: this.value,
            error: null,
            hint: '',
            mimeTypes: null,
            elementsDragOptions: {
                animation: 200,
                group: Math.random().toString(16).slice(2),
                disabled: false,
                ghostClass: 'ghost',
                handle: '.list-element-handler',
                draggable: 'tr',
                dragoverBubble: true
            }
        }
    },

    computed: {
        elementLocation() {
            if (this.location) {
                return this.location + '.' + this.element.name;
            }
            return this.element.name
        },
        labelExtraText() {
            if (this.element.hasOwnProperty('min_length') && this.element.hasOwnProperty('max_length') && this.element.min_length === this.element.max_length) {
                return ' ' + this.element.min_length + ' ' + t.__('elementów');
            }
            let text = '';
            if (this.element.hasOwnProperty('min_length') && this.element.min_length !== 0) {
                text += ' ' + t.__('od') + ' ' + this.element.min_length;
            }
            if (this.element.hasOwnProperty('max_length') && this.element.max_length !== 0) {
                text += ' ' + t.__('do') + ' ' + this.element.max_length;
            }
            if (text.length) {
                text += ' ' + t.__('elementów');
            }
            return text;
        }
    },

    beforeMount() {
        if (this.element.elements === undefined) {
            this.element.elements = [];
        }

        if (this.element.element.preferred_mime_type) {
            const preferredExtensions = Array.from(mime.getAllExtensions(this.element.element.preferred_mime_type))
            this.hint += '<strong>' + t.__('Zalecane rozszerzenie pliku: ') + preferredExtensions.join(', ') + '.</strong><br/>'
        }

        if (this.element.element.min_width >= 0 || this.element.element.max_width >= 0) {
            if (this.element.element.min_width === this.element.element.max_width) {
                this.hint += t.__('Szerokość') + ': ' + this.element.element.min_width + ' px.<br/>';
            } else {
                this.hint += t.__('Szerokość') + ': ';
                if (this.element.element.min_width > 0) {
                    this.hint += t.__('min.') + ' ' + this.element.element.min_width + ' px. ';
                }
                if (this.element.element.max_width > 0) {
                    this.hint += t.__('max.') + ' ' + this.element.element.max_width + ' px.';
                }
                this.hint += '<br/>';
            }
        }

        if (this.element.element.min_height >= 0 || this.element.element.max_height >= 0) {
            if (this.element.element.min_height === this.element.element.max_height) {
                this.hint += t.__('Wysokość') + ': ' + this.element.element.min_height + ' px.<br/>';
            } else {
                this.hint += t.__('Wysokość') + ': ';
                if (this.element.element.min_height > 0) {
                    this.hint += t.__('min.') + ' ' + this.element.element.min_height + ' px. ';
                }
                if (this.element.element.max_height > 0) {
                    this.hint += t.__('max.') + ' ' + this.element.element.max_height + ' px.';
                }
                this.hint += '<br/>';
            }
        }

        if (this.element.element.mime_types) {
            const allowedExtensions = this.element.element.mime_types.split(',')
                .map(mimeType => Array.from(mime.getAllExtensions(mimeType)))
                .flat();
            if (allowedExtensions.length) {
                this.hint += t.__('Dozwolone rozszerzenia: ') + allowedExtensions.join(', ') + '.<br/>'
            }
            this.mimeTypes = this.element.element.mime_types;
        }


    },

    mounted() {
        this.eventHub.$on('personalized-games-update-errors', errors => {
            if (errors[this.elementLocation] !== undefined) {
                this.error = errors[this.elementLocation];
            } else {
                this.error = null;
            }
        });
    },

    methods: {
        handleInput (e) {
            this.$emit('input', this.element)
        },

        addElement() {
            if (this.element.max_length !== 0 && this.element.elements.length >= this.element.max_length) {
                return;
            }
            let newElement = Object.assign({}, this.element.element);
            newElement.name = this.element.name + '_' + Math.random().toString(36).slice(-6);
            this.element.elements.push(newElement);
            this.$forceUpdate();
            this.handleInput();
        },

        removeElement(index) {
            this.$delete(this.element.elements, index)
            this.$forceUpdate();
            this.handleInput();
        }
    }

}
</script>

<style scoped>

.hint-text {
    font-size: 12px;
    color: white;
    margin-bottom: 10px;
}

.list-element-handler {
    background-image: url('/assets/images/quiz-handler-white.svg');
    height: 29px;
    width: 17px;
    margin-right: 10px;
    cursor: move;
}

</style>
